/** @format */

import { getDicts, getDictTypes } from '@/api/dict/data';
import * as V1 from '@/api/version-v1';

/**
 * 获取字典数据
 */
export function useDict(...args) {
	if ('V1' === window.pData.env.VITE_ENV_APP_BASE_API_VERSION) {
		return V1.useDict(...args);
	}
	const res = ref({});
	return (() => {
		args.forEach((d) => {
			res.value[d] = [];
			getDicts(d).then((resp: any) => {
				res.value[d] = resp;
			});
		});
		return toRefs(res.value);
	})();
}

/**
 * 获取字典类型数据
 */
export function useDictTypes(code) {
	const res = ref({});
	return (() => {
		res.value[code] = [];
		getDictTypes(code).then((resp) => {
			res.value[code] = resp;
		});
		return toRefs(res.value);
	})();
}
